module.exports = "/_next/static/images/1e37c043c28007d8ac6da3aae2b3592c-woman-playing-with-her-kids@lg.jpg.webp";